import {AfterViewInit, Component, ElementRef, Inject, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';

export enum GOOGLEADS {
  Ads970,
  Ads300
}

@Component({
  selector: 'app-template-slot',
  templateUrl: './template-slot.component.html',
  styleUrls: ['./template-slot.component.scss']
})
export class TemplateSlotComponent implements OnInit, AfterViewInit {
  @ViewChild('showBigTopEl') showBigTopEl: ElementRef;
  @ViewChild('showSmallTopEl') showSmallTopEl: ElementRef;
  @ViewChild('showBottomEl') showBottomEl: ElementRef;
  googleAds = GOOGLEADS;

  @Input() mode: GOOGLEADS = GOOGLEADS.Ads970;
  @Input() topBig: string = null;
  @Input() topSmall: string = null;
  @Input() bottom: string = null;

  constructor(
    @Inject(DOCUMENT) private document
  ) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const script1 = this.document.createElement('script');
    script1.text = `
            googletag.cmd.push(function () { googletag.display('` + this.topBig + `'); });
        `;
    this.showBigTopEl?.nativeElement?.appendChild(script1);

    const script2 = this.document.createElement('script');
    script2.text = `
            googletag.cmd.push(function() { googletag.display('` + this.topSmall + `'); });
        `;
    this.showSmallTopEl?.nativeElement?.appendChild(script2);

    const script3 = this.document.createElement('script');
    script3.text = `
            googletag.cmd.push(function() { googletag.display('` + this.bottom + `'); });
        `;
    this.showBottomEl?.nativeElement?.appendChild(script3);

  }


}
